module.exports = __webpack_public_path__ + "static/media/HomeGraphic6.e0721914.jpg";